<script>
import FeeTemplate from '@/components/widgets/service-fee-template.vue'
export default{
    name: 'du-service-template',
    components: {
        FeeTemplate,
    },
    props: {
        templates: {
            type: Array,
            required: false,
            default: () => []
        },
        useMeterReading: {
            type: Boolean,
            default: false
        },
        loading: Boolean
    },
    data(){
        return{
            selectedTemplate: {
                id: 0,
                deliveryUnitServiceFees: [],
                subscribers: [],
                menuSelection: 0,
                loadingTemplate: false,
                loadingSubscribers: false,
            },
        }
    },
    methods:{
        addTemplate(){
            this.$emit('add-template');
        },
        editTemplate(row){
            this.$emit('edit-template', row)
        },
        deleteTemplate(row){
            this.$emit('delete-template', row)
        },
        async selectTemplate(template){
            this.selectedTemplate = template;
        },
        addFeesToTemplate(fees){
            if(!this.selectedTemplate) return;
            fees.map(item => {
                item.percentage = '';
                this.selectedTemplate.deliveryUnitServiceFees.unshift(item);
            })
        },
        addFees(){
            this.$emit('add-fees', this.selectedTemplate.deliveryUnitServiceFees)
        },
    }
}
</script>
<template>
    <div class="d-flex gap-1">
        <div class="d-flex tmpl-parent">
            <a href="javascript:void(0)" class="card mb-0 border template-list shadow-none" @click="addTemplate">
                <p class="mb-0 d-flex align-items-center"><i class="bx bx-plus me-1 font-size-20"></i> Add New Template</p>
            </a>
            <template v-if="loading">
                <p class="my-5 text-center">Loading...</p>
            </template>
            <template v-if="!loading && !templates.length">
                <p class="text-center border py-5">No template found.</p>
            </template>
            <template v-for="x in templates">
                <a :key="x.id" href="javascript:void(0)" class="card mb-0 border template-list shadow-none" :class="{'active': x.id == selectedTemplate.id}" @click="selectTemplate(x)">
                    <p class="mb-0 d-flex align-items-center">{{x.templateName}}</p>
                </a>
            </template>
        </div>
        <div class="fee-parent">
            <template v-if="selectedTemplate.id != 0">
                <div class="d-flex justify-content-between mb-2">
                    <div>
                        <h5 class="mb-0">{{selectedTemplate.templateName}}</h5>
                        <small>{{selectedTemplate.templateDescription}}</small>
                    </div>
                    <div class="d-flex gap-1">
                        <button class="btn btn-danger ms-1" @click="deleteTemplate(selectedTemplate)"><i class="bx bx-trash"></i> Delete Template</button>
                        <button class="btn btn-primary" @click="editTemplate(selectedTemplate)"><i class="bx bx-edit"></i> Edit Template</button>
                    </div>
                </div>
                <FeeTemplate 
                    :template="selectedTemplate"
                    :useMeterReading="useMeterReading"
                    @addFees="addFees"
                />
            </template>
            <div v-else class="no-template" >
                <p class="text-center font-size-20">Select a template to view details</p>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.no-template{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}
.tmpl-parent{
    width: 300px;
    flex-shrink: 0;
    padding-right: 10px;
    flex-direction: column;
    gap: 5px;
}
.template-list{
    flex-shrink: 0;
    width: 100%;
    min-height: 50px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.active{
        background: var(--bs-primary);
        color: #fff;
    }
}
.fee-parent{
    border-left: 1px solid var(--bs-gray-300);
    flex-shrink: 0;
    padding-inline: 10px;
    width: calc(100% - 310px);
}
.temp-options{
    border: 1px solid var(--bs-gray-300);
    padding: 10px;
    min-width: 140px;
    text-align: center;
    border-radius: 25px;
    &.active{
        color: #fff;
        background: var(--bs-primary);
    }
}
</style>